import { load } from "isomorphic-cookie";
var usrLocaleCookieName = "UsrLocale";
var jSessionIdCookieName = "JSESSIONID";
var correlationIdCookieName = "lll-ecom-correlation-id";
export var getCorrelationId = function(req) {
    return load(correlationIdCookieName, req, false) || "";
};
export var getJSessionId = function(req) {
    return load(jSessionIdCookieName, req, false) || "";
};
export var getUsrLocale = function(req) {
    return load(usrLocaleCookieName, req, false) || "";
};
